import React from 'react'
import ellipse1 from '../../assets/images/ellipse2.svg'
import ellipse2 from '../../assets/images/ellipse1.svg'

const Background = () => {
    return (
        <div className='background'>
            <img src={ellipse1} alt='' className='ellipse1' />
            <img src={ellipse2} alt='' className='ellipse2' />
        </div>
    )
}

export default Background
